/**
 * @generated SignedSource<<8e987855dc9f2a3991f22b6a8c922080>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offset"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectId"
},
v4 = {
  "kind": "Variable",
  "name": "customerId",
  "variableName": "accountId"
},
v5 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v6 = {
  "kind": "Variable",
  "name": "offset",
  "variableName": "offset"
},
v7 = {
  "kind": "Literal",
  "name": "orderBy",
  "value": "ACCEPTED_TIME_DESC"
},
v8 = [
  {
    "fields": [
      (v4/*: any*/)
    ],
    "kind": "ObjectValue",
    "name": "condition"
  },
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "orderId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "orderDescription",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "orderStatus",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "acceptedTime",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "previousOrder",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "replacingOrder",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectId",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lineType",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billingFrequency",
  "storageKey": null
},
v19 = [
  (v9/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "OrderT",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "OrderLineTsConnection",
        "kind": "LinkedField",
        "name": "orderLineTsByOrderId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "OrderLineT",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v17/*: any*/),
              (v18/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v20 = [
  {
    "fields": [
      (v4/*: any*/),
      {
        "kind": "Variable",
        "name": "projectId",
        "variableName": "projectId"
      }
    ],
    "kind": "ObjectValue",
    "name": "condition"
  },
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/)
],
v21 = {
  "kind": "Variable",
  "name": "accountid",
  "variableName": "accountId"
},
v22 = {
  "alias": null,
  "args": [
    (v21/*: any*/)
  ],
  "kind": "ScalarField",
  "name": "issubscriptionorderoutstanding",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": [
    (v21/*: any*/),
    {
      "kind": "Variable",
      "name": "projectid",
      "variableName": "projectId"
    }
  ],
  "kind": "ScalarField",
  "name": "issubscriptionorderoutstandingforproject",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v25 = [
  (v9/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "OrderT",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "OrderLineTsConnection",
        "kind": "LinkedField",
        "name": "orderLineTsByOrderId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "OrderLineT",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v17/*: any*/),
              (v18/*: any*/),
              (v24/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v24/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SubscriptionOrdersQuery",
    "selections": [
      {
        "alias": "ordersWithoutProject",
        "args": (v8/*: any*/),
        "concreteType": "OrderTsConnection",
        "kind": "LinkedField",
        "name": "allOrderTs",
        "plural": false,
        "selections": (v19/*: any*/),
        "storageKey": null
      },
      {
        "alias": "ordersForProject",
        "args": (v20/*: any*/),
        "concreteType": "OrderTsConnection",
        "kind": "LinkedField",
        "name": "allOrderTs",
        "plural": false,
        "selections": (v19/*: any*/),
        "storageKey": null
      },
      (v22/*: any*/),
      (v23/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "SubscriptionOrdersQuery",
    "selections": [
      {
        "alias": "ordersWithoutProject",
        "args": (v8/*: any*/),
        "concreteType": "OrderTsConnection",
        "kind": "LinkedField",
        "name": "allOrderTs",
        "plural": false,
        "selections": (v25/*: any*/),
        "storageKey": null
      },
      {
        "alias": "ordersForProject",
        "args": (v20/*: any*/),
        "concreteType": "OrderTsConnection",
        "kind": "LinkedField",
        "name": "allOrderTs",
        "plural": false,
        "selections": (v25/*: any*/),
        "storageKey": null
      },
      (v22/*: any*/),
      (v23/*: any*/)
    ]
  },
  "params": {
    "cacheID": "a4a0225ba495e7668e4d866fb0f48a4f",
    "id": null,
    "metadata": {},
    "name": "SubscriptionOrdersQuery",
    "operationKind": "query",
    "text": "query SubscriptionOrdersQuery(\n  $accountId: UUID!\n  $projectId: UUID!\n  $first: Int\n  $offset: Int\n) {\n  ordersWithoutProject: allOrderTs(condition: {customerId: $accountId}, first: $first, offset: $offset, orderBy: ACCEPTED_TIME_DESC) {\n    totalCount\n    nodes {\n      orderId\n      orderDescription\n      orderStatus\n      acceptedTime\n      previousOrder\n      replacingOrder\n      projectId\n      orderLineTsByOrderId {\n        nodes {\n          lineType\n          billingFrequency\n          nodeId\n        }\n      }\n      nodeId\n    }\n  }\n  ordersForProject: allOrderTs(condition: {customerId: $accountId, projectId: $projectId}, first: $first, offset: $offset, orderBy: ACCEPTED_TIME_DESC) {\n    totalCount\n    nodes {\n      orderId\n      orderDescription\n      orderStatus\n      acceptedTime\n      previousOrder\n      replacingOrder\n      projectId\n      orderLineTsByOrderId {\n        nodes {\n          lineType\n          billingFrequency\n          nodeId\n        }\n      }\n      nodeId\n    }\n  }\n  issubscriptionorderoutstanding(accountid: $accountId)\n  issubscriptionorderoutstandingforproject(accountid: $accountId, projectid: $projectId)\n}\n"
  }
};
})();

node.hash = "b750646b8cfe167497d7d6d78b289fec";

module.exports = node;
